module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns() 
    ; __append("\n")
    ;  var actions = widget.gridActions() 
    ; __append("\n\n")
    ;  Util.each(columns, function (column) { 
    ; __append("\n<col width=\"")
    ; __append(escapeFn( column.width ? column.width : "*" ))
    ; __append("\">\n")
    ;  }) 
    ; __append("\n\n")
    ;  Util.each(actions, function (action) { 
    ; __append("\n<col width=\"")
    ; __append(escapeFn( action.width ? action.width : "*" ))
    ; __append("\">\n")
    ;  }) 
    ; __append("\n")
  }
  return __output.join("");

}